import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { TRANSACTION_PATH } from '../../../../config/paths';
import { clearTransaction, getTransaction } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import NoDataResource from '../../../common/resource/NoDataResource';
import TransactionBasicInformationResource from './resource/TransactionBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const Transaction = ({
  breadcrumbs,
  match: {
    params: { id: transactionId },
  },
  transaction,
  loading,
  dispatchGetTransaction,
  dispatchClearTransaction,
}) => {
  useLayoutEffect(() => {
    dispatchGetTransaction({ transactionId });

    return () => dispatchClearTransaction();
  }, []);

  let content = null;
  if (loading) content = <Loader />;
  else if (transaction.isEmpty()) {
    content = <NoDataResource returnPage={TRANSACTION_PATH} />;
  } else {
    const transactionJSON = transaction.toJS();
    content = (
            <>
              <h3>Información Básica</h3>
              <TransactionBasicInformationResource {...transactionJSON} />
              <InternalResource id={transactionJSON.id}
                        createDate={transactionJSON.createDate}
                        lastUpdate={transactionJSON.lastUpdate}/>
            </>
      
  );
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Transacción"
      content={content}
    />
  );
};

Transaction.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  transaction: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetTransaction: PropTypes.func.isRequired,
  dispatchClearTransaction: PropTypes.func.isRequired,
};

Transaction.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Transacciones',
      href: TRANSACTION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  transaction: AccountingUnit.Transaction.getIn(['current', 'content']),
  loading: !AccountingUnit.Transaction.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetTransaction: getTransaction,
  dispatchClearTransaction: clearTransaction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Transaction);
